export default __webpack_public_path__ + "static/media/IconXlsx.f299f518.svg";